import axios from 'axios';
import API_CONFIG from '../config/api';

interface PriceCalculationRequest {
  product_id: string;
  customer_id: string;
  payment_term?: string;
  address_id?: string;
}

interface PriceCalculationResponse {
  final_price: number;
  customer_uf?: string;
}

interface ApiResponse {
  success: boolean;
  data: PriceCalculationResponse;
  error?: string;
}

// Calculate price based on product and customer
export const calculatePrice = async (data: PriceCalculationRequest): Promise<ApiResponse> => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.post(
      `${API_CONFIG.BASE_URL_WITH_VERSION}/pricing/calculate`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    // Strip sensitive information from the response
    // Only keep final_price and customer_uf
    const sanitizedData: PriceCalculationResponse = {
      final_price: response.data.final_price,
      customer_uf: response.data.customer_uf,
    };

    return {
      success: true,
      data: sanitizedData,
    };
  } catch (error: any) {
    console.error('Error calculating price:', error);
    return {
      success: false,
      data: { final_price: 0 },
      error: error.response?.data?.message || 'Failed to calculate price',
    };
  }
};
